"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const react_i18next_1 = require("react-i18next");
const core_1 = require("@material-ui/core");
const Save_1 = (0, tslib_1.__importDefault)(require("@material-ui/icons/Save"));
const infra_1 = require("@monorepo/infra");
const molecules_1 = require("../../../molecules");
const S = (0, tslib_1.__importStar)(require("./styles"));
const EditProfile = (_a) => {
    var { onSubmit } = _a, props = (0, tslib_1.__rest)(_a, ["onSubmit"]);
    const { t } = (0, react_i18next_1.useTranslation)('forms');
    const history = (0, react_router_dom_1.useHistory)();
    const [userId, setUserId] = (0, react_1.useState)('');
    const [firstName, setFirstName] = (0, react_1.useState)('');
    const [lastName, setLastName] = (0, react_1.useState)('');
    const [email, setEmail] = (0, react_1.useState)('');
    const [phoneNumber, setPhoneNumber] = (0, react_1.useState)('');
    const { billingAddresses, shippingAddresses, defaultBillingAddress, defaultShippingAddress, dispatchBillingAddresses, dispatchShippingAddresses, dispatchDefaultBillingAddress, dispatchDefaultShippingAddress, } = (0, react_1.useContext)(infra_1.AddressesContext);
    (0, react_1.useEffect)(() => {
        setUserId(props._id);
        setFirstName(props.firstName);
        setLastName(props.lastName);
        setEmail(props.email);
        setPhoneNumber(props.phoneNumber);
        dispatchBillingAddresses({
            type: infra_1.ActionAdressType.SetAddressesList,
            payload: { addresses: props.billingAddresses },
        });
        dispatchShippingAddresses({
            type: infra_1.ActionAdressType.SetAddressesList,
            payload: { addresses: props.shippingAddresses },
        });
        dispatchDefaultBillingAddress({
            type: infra_1.ActionAdressType.InitializeDefaultAddress,
            payload: { value: billingAddresses },
        });
        dispatchDefaultShippingAddress({
            type: infra_1.ActionAdressType.InitializeDefaultAddress,
            payload: { value: shippingAddresses },
        });
    }, [
        billingAddresses,
        shippingAddresses,
        props._id,
        props.firstName,
        props.lastName,
        props.email,
        props.phoneNumber,
        props.billingAddresses,
        props.shippingAddresses,
        dispatchShippingAddresses,
        dispatchBillingAddresses,
        dispatchDefaultBillingAddress,
        dispatchDefaultShippingAddress,
    ]);
    const handleSubmit = (event) => {
        event.preventDefault();
        dispatchBillingAddresses({
            type: infra_1.ActionAdressType.ReplaceDefaultAddress,
            payload: { address: defaultBillingAddress },
        });
        dispatchShippingAddresses({
            type: infra_1.ActionAdressType.ReplaceDefaultAddress,
            payload: { address: defaultShippingAddress },
        });
        const newBillingAddresses = (0, infra_1.replaceElement)(billingAddresses, defaultBillingAddress);
        const newShippingAddresses = (0, infra_1.replaceElement)(shippingAddresses, defaultShippingAddress);
        onSubmit({
            firstName,
            lastName,
            email,
            phoneNumber,
            billingAddresses: newBillingAddresses,
            shippingAddresses: newShippingAddresses,
        });
    };
    const hadleCancel = () => {
        history.goBack();
    };
    return ((0, jsx_runtime_1.jsx)(S.Form, Object.assign({ onSubmit: handleSubmit }, { children: (0, jsx_runtime_1.jsxs)(core_1.Grid, Object.assign({ container: true, spacing: 2 }, { children: [(0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ item: true, xs: 12, sm: 6 }, { children: (0, jsx_runtime_1.jsx)(S.Input, { id: "firstname", name: "firstname", onChange: (event) => setFirstName(event.target.value), value: firstName, label: t('profile.inputs.firstName.label'), placeholder: t('profile.inputs.firstName.placeholder') }, void 0) }), void 0), (0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ item: true, xs: 12, sm: 6 }, { children: (0, jsx_runtime_1.jsx)(S.Input, { id: "lastname", name: "lastname", onChange: (event) => setLastName(event.target.value), value: lastName, label: t('profile.inputs.lastName.label'), placeholder: t('profile.inputs.lastName.placeholder') }, void 0) }), void 0), (0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ item: true, xs: 12, sm: 8 }, { children: (0, jsx_runtime_1.jsx)(S.Input, { id: "email", name: "email", onChange: (event) => setEmail(event.target.value), value: email, type: "email", label: t('profile.inputs.email.label'), placeholder: t('profile.inputs.email.placeholder') }, void 0) }), void 0), (0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ item: true, xs: 12, sm: 4 }, { children: (0, jsx_runtime_1.jsx)(S.Input, { id: "phonenumber", name: "phonenumber", onChange: (event) => setPhoneNumber(event.target.value), value: phoneNumber, label: t('profile.inputs.phoneNumber.label'), placeholder: t('profile.inputs.phoneNumber.placeholder') }, void 0) }), void 0), (0, jsx_runtime_1.jsx)(molecules_1.Address, { title: "Billing Address", address: defaultBillingAddress, userId: userId, dispatchAddress: dispatchDefaultBillingAddress, addresses: billingAddresses }, void 0), (0, jsx_runtime_1.jsx)(molecules_1.Address, { title: "Shipping Address", userId: userId, address: defaultShippingAddress, dispatchAddress: dispatchDefaultShippingAddress, addresses: shippingAddresses }, void 0), (0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ item: true, xs: 6 }, { children: (0, jsx_runtime_1.jsx)(core_1.Button, Object.assign({ variant: "outlined", type: "button", onClick: hadleCancel, fullWidth: true }, { children: "Cancel" }), void 0) }), void 0), (0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ item: true, xs: 6 }, { children: (0, jsx_runtime_1.jsx)(core_1.Button, Object.assign({ variant: "contained", endIcon: (0, jsx_runtime_1.jsx)(Save_1.default, {}, void 0), type: "submit", fullWidth: true }, { children: "Update" }), void 0) }), void 0)] }), void 0) }), void 0));
};
exports.default = EditProfile;
